import React from 'react';

import { useRouter } from 'next/router';
import { Product, WithContext } from 'schema-dts';

import { APP_URL } from '@utils/env';
import { getLargeImageUrl } from '@utils/images';
import { getAvailabilityUrl } from '@utils/product/attributes';

import { SchemaScript } from '@components/common/SchemaOrg/SchemaScript';

type ProductSchemaProps = {
    name: string;
    description: string | null;
    image: Global.ImageSet;
    sku: string;
    price: number;
    oldPrice: number | null;
    measureUnit: string;
    isAvailable: boolean;
};

export const ProductSchema: React.FC<ProductSchemaProps> = ({
    name,
    description,
    image,
    sku,
    price,
    oldPrice,
    measureUnit,
    isAvailable,
}) => {
    const { asPath } = useRouter();

    const baseUrl = APP_URL;
    const imageUrl = getLargeImageUrl(image);
    const productUrl = `${baseUrl}${asPath}`;

    const schema: WithContext<Product> = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name,
        image: imageUrl,
        description: description || undefined,
        sku,
        brand: {
            '@type': 'Brand',
            name: 'Гурман-М',
        },
        offers: {
            '@type': 'Offer',
            price: price.toString(),
            priceCurrency: 'RUB',
            availability: getAvailabilityUrl(isAvailable),
            url: productUrl,
            ...(oldPrice && {
                highPrice: oldPrice.toString(),
                lowPrice: price.toString(),
            }),
        },
        additionalProperty: [
            {
                '@type': 'PropertyValue',
                name: 'Единица продажи',
                value: measureUnit,
            },
        ],
    };

    return <SchemaScript id={`product-schema-${sku}`} schema={schema} />;
};
